async function devtricker_process_recommendation_account_loadRecommendedAccounts() {

    if (devtricker_dom_get_isToLoadRecommendadAccounts()) {

        let element = devtricker_dom_get_recommendadAccountSection();

        let content = await devtricker_ajax_get_suggestedAccounts();

        let currentAside = element.querySelector('aside');
        currentAside.remove();

        const data = content.querySelectorAll('.list-group-item');
        if (data.length > 0) {
            element.appendChild(content);
        }

        devtricker_process_initializeAllHovercards();
        devtricker_proccess_recommendation_account_initializeFollowButtons();
    }
}

async function devtricker_proccess_recommendation_account_initializeFollowButtons() {

    let buttons = devtricker_dom_get_recommendation_account_followButtons();

    if (buttons) {
        for (let button of buttons) {

            let isFollowing = devtricker_session_isFollowing(button.getAttribute('data-author-id'));

            if (isFollowing) {
                devtricker_makeTheFollowButtonReadyToUnfollow(button);
            } else {
                devtricker_makeTheFollowButtonReadyToFollow(button);
            }
        }
    }
}